<template>
  <q-dialog v-model="visible" persistent>
    <q-card class="container">
      <div class="modal-header">
        <q-card-section class="header">
          <div class="header-content-wrapper">
            <div class="header-title">{{ this.$gettext('INDUSTRIAL_MAP_ROUND') }} - {{ rondaData.driverName || this.$gettext('INDUSTRIAL_MAP_RESPONSIBLE_NAME') }}</div>
            <q-btn flat round color="white" icon="close" @click="onClose" class="header-close-btn" />
          </div>
        </q-card-section>
      </div>

      <div class="modal-body">
        <div class="content">
          <div v-if="loading" class="loading-section">
            <q-inner-loading :showing="loading">
              <q-spinner-gears size="80px" color="primary" />
            </q-inner-loading>
          </div>

          <div v-if="hasError" class="text-negative text-center q-pa-md">
            {{ errorMessage }}
          </div>

          <div class="modal-body-hoje" v-else-if="!loading">
            <div class="text-subtitle1 q-mb-md">{{ rondaData.integrationCode || this.$gettext('INDUSTRIAL_MAP_ROUND_NAME') }} - 00:00 à 00:00</div>

            <div class="text-h6 q-mb-sm">{{ this.$gettext('INDUSTRIAL_MAP_ATTENTION_POINTS') }}</div>
            <div class="card-hoje">
              <q-list >
                <q-item v-for="(ponto, index) in pontosInspecionados" :key="index" class="collection-detail-item collection-line">
                  <div class="collection-col1">{{ ponto.name || this.$gettext('INDUSTRIAL_MAP_POINT_NOT_IDENTIFIED') }}</div>
                  <div class="collection-col2">{{ this.$gettext('INDUSTRIAL_MAP_OBSERVATION') }}: {{ ponto.observacoes || this.$gettext('INDUSTRIAL_MAP_NO_OBSERVATIONS') }}</div>
                </q-item>
                <q-item v-if="!pontosInspecionados.length">
                  <q-item-section>{{ this.$gettext('INDUSTRIAL_MAP_NO_INSPECTED_POINTS') }}</q-item-section>
                </q-item>
              </q-list>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <q-card-actions align="center" class="footer">
          <q-btn :label="$gettext('INDUSTRIAL_MAP_BTN_CLOSE')" color="grey-7" class="btn-fechar" @click="onClose" />
        </q-card-actions>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { IndustrialMapRepository } from 'src/modules/industry/industrial-map/IndustrialMapRepository.js'

@Component({
  name: 'ModalDetalhesRondas'
})
class ModalDetalhesRondas extends Vue {
  @Prop({ type: Boolean, default: false })
  value

  @Prop({ type: Object, default: () => ({}) })
  ronda

  loading = false
  hasError = false
  errorMessage = ''
  rondaDetails = null

  get visible () {
    return this.value
  }

  set visible (val) {
    this.$emit('input', val)
  }

  get rondaData () {
    return this.rondaDetails || this.ronda || {}
  }

  get formattedScheduledDate () {
    if (this.rondaData.scheduledDate) {
      return moment(this.rondaData.scheduledDate).format('DD/MM/YYYY - HH:mm')
    }
    return 'Data não informada'
  }

  get pontosInspecionados () {
    return this.rondaData.executionSummary?.pontosInspecionados || []
  }

  onClose () {
    this.visible = false
    this.$emit('close')
  }

  @Watch('visible')
  async onModalOpen (isVisible) {
    if (isVisible && this.ronda?.id) {
      await this.loadRondaDetails()
    }
  }

  async loadRondaDetails () {
    try {
      this.loading = true
      // Como não há método específico para ronda no repository, usar método genérico ou implementar
      const response = await IndustrialMapRepository.mountCollectionDetail(this.ronda.id)

      if (response) { // Assuming response.success is not always present in mock
        this.rondaDetails = response
        this.hasError = false
        this.errorMessage = ''
      } else {
        this.hasError = true
        this.errorMessage = 'Não foi possível exibir o registro.'
        console.error('Erro ao carregar detalhes da ronda: Resposta inválida', response)
      }
    } catch (error) {
      this.hasError = true
      this.errorMessage = 'Não foi possível exibir o registro. Erro: ' + error.message
      console.error('Erro ao carregar detalhes da ronda:', error)
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('INDUSTRIAL_MAP_ERROR_LOAD_ROUND_DETAILS')
      })
    } finally {
      this.loading = false
    }
  }
}

export default ModalDetalhesRondas
</script>

<style lang="stylus" scoped>
.container
  width: 920px
  max-width: 920px
  height: 640px
  max-height: 640px
  border-radius: 10px
  padding-top: 16px
  background: white
  display: flex
  flex-direction: column
  gap: 20px
  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px rgba(0,0,0,0.14), 0 1px 10px rgba(0,0,0,0.12)

.modal-header
  flex-shrink: 0;

.header
  height: 50px
  padding: 8px 20px
  border-radius: 4px
  color: white !important
  flex-shrink: 0
  background-color: #1E4971

.coletas-realizadas-header
  background-color: #0F5295

.header-content-wrapper
  width: 856px
  height: 34px
  gap: 20px
  display: flex
  align-items: center
  justify-content: space-between
  margin: 0 auto

.header-title
  height: 34px
  font-family: Roboto
  font-weight: 700
  font-style: Bold
  font-size: 28px
  line-height: 34px
  flex-grow: 1

.header-close-btn
  flex-shrink: 0
  cursor: pointer; /* Add cursor pointer for better UX */
  margin: 0;

.modal-body
  height: 544px; /* Adjusted height */
  overflow-y: auto;
  padding: 0px 16px 0px 0px; /* Add padding to right */
  & .modal-body-hoje
    border: 1px solid #E0E0E0
    width: 888;
    height: 320;
    gap: 16px;
    angle: 0 deg;
    opacity: 1;
    border-width: 1px;
    border-radius: 8px;
    padding: 16px;

.content
  gap: 8px
  display: flex
  flex-direction: column
  flex-grow: 0
  padding: 0px 0px 0px 16px; /* Add padding to left */
  width: 888px;

.modal-footer
  flex-shrink: 0;

.footer
  height: 60px
  gap: 20px
  padding: 12px 0; /* Add padding to top and bottom */
  background: #FFFFFF /* Change background color */
  display: flex
  justify-content: center /* Center the button horizontally */
  align-items: center
  flex-shrink: 0

.container1
  width: 888px
  height: 362px
  gap: 20px
  display: flex
  flex-direction: column
  flex-shrink: 0

.container2
  width: 888px
  gap: 8px
  display: flex
  flex-direction: column
  flex-grow: 0
  overflow-y: auto

.text-modal-body
  color: #31CCCB

.div-inside-container1
  width: 888px
  gap: 16px
  border-width: 1px
  border-radius: 8px
  padding: 16px
  background: #FCFCFC
  border: 1px solid #E0E0E0
  display: flex
  flex-direction: column
  flex-shrink: 0

.div-subtitulo
  width: 149px
  height: 21px
  gap: 10px
  border-bottom: 2px solid #0062a9
  display: flex
  align-items: center
  flex-shrink: 0

.container-coletas
  width: 856px
  height: 128px
  gap: 16px
  display: flex
  flex-direction: row
  justify-content: space-between
  flex-shrink: 0

.coletas-feitas-block, .qtd-coletada-block
  width: 420px
  height: 128px
  padding: 16px
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  border-radius: 8px
  flex-shrink: 0

.card-hoje
  width: 856px
  height: 149px
  gap: 8px
  border-radius: 8px
  padding: 12px 0 0 12px
  border-left: 3px solid #0679CC
  background: #FFFFFF
  overflow-y: hidden
  flex-shrink: 0

.btn-fechar
  width 120px

.loading-section
  min-height 200px
  display flex
  align-items center
  justify-content center
  padding-top 40px
  padding-bottom 40px
  flex-grow: 1

.collection-detail-item.collection-line
  width: 832px !important
  height: 26px !important
  min-height: 26px !important
  padding: 0px !important
  margin: 0 auto
  margin-bottom: 16px; /* Increased margin */
  border-radius 4px
  display: flex
  align-items: center
  justify-content: space-between
  gap: 16px
  flex-shrink: 0

.collection-col1
  width: 270px !important
  height: 26px !important
  padding: 8px !important
  flex-shrink: 0
  line-height: 1.5;
  display: flex;
  flex-direction: row;
  background-color #f5f5f5
  justify-content: space-between;

.collection-col2
  width: 546px !important
  height: 26px !important
  padding: 8px !important
  flex-shrink: 0
  background-color #f5f5f5
</style>
